import { useTranslation } from "react-i18next";

import { useConfigSettings } from "../useConfigSettings";

export const useLoginFormSettings = () => {
  const { t } = useTranslation();
  const {
    loginForm,
    withPortal,
    allowRegistration,
    allowSNS,
    allowRecovery,
    showTermsOfService,
    disabledComponents,
    signupByInvite,
  } = useConfigSettings();
  const { title, login, password, loginWith, terms, button, remember, signUp } = loginForm || {};

  return {
    title: title || t("loginTitle"),
    login: login || t("login"),
    password: password || t("password"),
    button: button || t("signIn"),
    remember: remember || t("forgotLoginPassword"),
    signUp: signUp || (signupByInvite ? t("getAccess") : t("signUp")),
    loginWith: loginWith || t("loginWith"),
    terms,
    withPortal,
    allowRegistration,
    allowSNS,
    allowRecovery,
    showTermsOfService,
    disabledComponents,
  };
};
